import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Supervisor } from './supervisor';
import { RequestOptions, Headers } from '@angular/http';
import { TransactionService } from './transaction.service';
import { baseUrl, loginFile, gatewayFile } from './endpoint';
import { GlobalEventsManager } from './global-events-manager';

@Injectable({
  providedIn: 'root'
})
export class FsService {

  private url = baseUrl + gatewayFile;

  supervisors: Supervisor[];

  constructor(
    private http: HttpClient,
    private globalEventsManager: GlobalEventsManager
  ) { }

  getSupervisors(site: string): Observable<Supervisor[]> {
    const url = `${this.url}`;
    return this.http.post<Supervisor[]>(url, { token: localStorage.getItem('token'), function: 'getSupervisors', item1: site })
    .pipe(
      catchError(this.handleError('getSupervisors', []))
    );
  }

  removeByItemId(itemId: string) {
    const url = `${this.url}`;
    return this.http.post<string>(url, { token: localStorage.getItem('token'), function: 'removeFsItemById', item1: itemId})
    .pipe(
      catchError(this.handleError('removeByItemId', []))
    );
  }

  getSupervisorList(): Observable<Supervisor[]> {
    const url = `${this.url}`;
    return this.http.post<Supervisor[]>(url, { token: localStorage.getItem('token'), function: 'getSupervisorList' })
    .pipe(
      catchError(this.handleError('getSupervisorList', []))
    );
  }

  addSupervisor(siteId: string, shift: string, inspId: string, createdBy: string) {
    const url = `${this.url}`;
    return this.http.post<string>(url, { token: localStorage.getItem('token'), function: 'addSupervisor',
      item1: siteId, item2: shift, item3: inspId, item4: createdBy})
    .pipe(
      catchError(this.handleError('addSupervisor', []))
    );
  }

  updateSupervisor(itemId: string, siteId: string, shift: string, inspId: string, createdBy: string) {
    const url = `${this.url}`;
    return this.http.post<string>(url, { token: localStorage.getItem('token'), function: 'updateSupervisor',
      item1: itemId, item2: siteId, item3: shift, item4: inspId, item5: createdBy})
    .pipe(
      catchError(this.handleError('updateupervisor', []))
    );
  }

  emailSupervisor(site: string, shift: string, otherFS: string, insps: string, reqs: string, email: string, date: string, address: any) {
    const url = `${this.url}`;
    return this.http.post<string>(url, { token: localStorage.getItem('token'), function: 'emailSupervisor',
      item1: site, item2: shift, item3: otherFS, item4: insps, item5: reqs, item6: email, item7: date, item8: address })
    .pipe(
      catchError(this.handleError('emailSupervisor', []))
    );
  }

  toggleFSWork(id: any, day: any) {
    const url = `${this.url}`;
    return this.http.post<string>(url, { token: localStorage.getItem('token'), function: 'toggleFSWork', item1: id, item2: day })
    .pipe(
      catchError(this.handleError('toggleWork', []))
    );
  }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      if (error.error.text === 'expire') {
        this.globalEventsManager.logout(true);
      } else {
        if (error.error.text !== 'Could not Authenticate User') {
          console.error(error);
        }
      }
      return of(result as T);
    };
  }
}
